export enum LessonPageItemTypeEnum {
    TEXT = 'Text',
    VIDEO = 'Video',
    QUIZ = 'Quiz'
}